import SkapaInput, {
  type InputFieldAttributes,
  type InputFieldProps,
} from "@ingka/input-field";
import React, { forwardRef } from "react";

export type InputProps = InputFieldProps &
  InputFieldAttributes &
  React.RefAttributes<HTMLInputElement> & {
    autoFocus?: boolean;
  };

// eslint-disable-next-line react/display-name
export const Input = forwardRef(
  (props: InputProps, ref: React.ForwardedRef<HTMLInputElement>) => {
    return (
      <SkapaInput
        prefix="saleslead__"
        ref={ref}
        {...props}
        autoComplete="off"
      />
    );
  }
);
